import { render, staticRenderFns } from "./ReSearchFlatsGrid.vue?vue&type=template&id=22fb6507"
import script from "./ReSearchFlatsGrid.vue?vue&type=script&lang=js"
export * from "./ReSearchFlatsGrid.vue?vue&type=script&lang=js"
import style0 from "./ReSearchFlatsGrid.vue?vue&type=style&index=0&id=22fb6507&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports